export default function createActiveStorageUploadAdapter(ActiveStorageUploadPlugin) {
    return class ActiveStorageUploadAdapter {
        static VERSION = ActiveStorageUploadPlugin.VERSION

        constructor(uppy, opts) {
            this.uppy = uppy
            this.plugin = new ActiveStorageUploadPlugin(uppy, opts)
            this.id = this.plugin.id
            this.type = this.plugin.type
        }

        install() {
            if (!this.plugin.uppy) {
                this.plugin.uppy = this.uppy
            }

            return this.plugin.install?.call(this.plugin)
        }

        uninstall() {
            return this.plugin.uninstall?.call(this.plugin)
        }

        update(state) {
            return this.plugin.update?.call(this.plugin, state)
        }

        afterUpdate() {
            return this.plugin.afterUpdate?.call(this.plugin)
        }
    }
}
